import { useEffect, useState } from 'react';
import { api } from './api';

// Session cache so /public-config is fetched once.
let cache = null;
let promise = null;

export function loadPublicConfig() {
  if (cache) return Promise.resolve(cache);
  if (promise) return promise;
  promise = api.get('/public-config')
    .then((r) => { cache = r.data || {}; return cache; })
    .catch(() => { cache = {}; return cache; });
  return promise;
}

export function usePublicConfig() {
  const [config, setConfig] = useState(cache);
  useEffect(() => {
    let alive = true;
    if (!cache) loadPublicConfig().then((c) => { if (alive) setConfig(c); });
    return () => { alive = false; };
  }, []);
  return config; // null while loading
}
